import React, {useState, useEffect} from 'react'

export default function useOnScreen(ref:React.MutableRefObject<HTMLElement | undefined>, container: Element | null  = null) {

    const [isIntersecting, setIntersecting] = useState(false)

    let observer: IntersectionObserver 

    useEffect(() => {
        return () => {
            if(observer) {
                observer.disconnect();
            }
        }
    }, []);
  
    useEffect(() => {
        observer = new IntersectionObserver(([entry]) => {
            setIntersecting(entry.isIntersecting)
        }, {
            root: container,
            rootMargin:  '55px',
            threshold: 0
        });
        
        if(ref && ref.current) {
            observer.observe(ref.current)
        }
    }, [container])
  
    return isIntersecting
  }